import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, debounce } from 'lodash';

import './scss/sider.scss';
import Color from '@tool/color';
import {
  EffectIcon11, EffectIcon12, EffectIcon13, EffectIcon14,
  DownFullIcon, EffectIcon11Gray, EffectIcon12Gray,
  EffectIcon13Gray, EffectIcon14Gray,
} from '@styled/icon';
import moSider, {
  siderInit, toggleExpand, changeTop, changeModule,
} from './store/sider';

interface IProps {}
interface IState {}

const CButton = styled(Button)(() => ({
  height: '32px',
  width: '100%',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  padding: '10px',
  marginBottom: '8px',
  fontSize: '13px',
  fontWeight: 500,
  borderRadius: '4px',
  color: Color.blackColor(0.85),

  '& .MuiButton-startIcon': { margin: 0 },
  '& .text-155': { marginLeft: '10px' },
  '& .text-156': {
    marginLeft: '6px',
    fontWeight: 600,
  },
  '& .active-156': { color: Color.primary },
}));

const HeadButton = styled(CButton)(() => ({
  backgroundColor: Color.f7,
  '&:hover': { backgroundColor: Color.ec },
}));

const TitleButton = styled(CButton)(() => ({
  paddingLeft: '20px',
  '&.active, &:hover': {
    color: Color.primary,
    backgroundColor: Color.primaryColor(0.05),
  },
}));

const Sider = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { isExpand, activeName, siderTop } = moSider;
  const siderList = [
    {
      title: '人力资源效能',
      arr: [
        { name: '行业对比', key: '人效行业对比' },
        { name: '时间趋势', key: '人效时间趋势' },
        { name: '变化率分布', key: '人效变化率分布' },
        { name: '人力资本回报分析', key: '人力资本回报分析' },
        { name: '员工规模与元均效能', key: '员工规模与元均效能' },
        { name: '人力投入与产出TOP10', key: 'Top10公司列表' },
        { name: '招聘量与营收', key: '招聘量与营收' },
      ],
    },
    {
      title: '薪酬成本投入',
      arr: [
        { name: '行业对比', key: '薪酬成本行业对比' },
        { name: '时间趋势', key: '薪酬成本时间趋势' },
        { name: '费用中的薪酬占比', key: '费用中的薪酬占比' },
      ],
    },
    {
      title: '人员配置',
      arr: [
        { name: '行业对比', key: '人员配置行业对比' },
        { name: '时间趋势', key: '人员配置时间趋势' },
        { name: '变化率分布', key: '人员配置变化率分布' },
        { name: '员工构成时间趋势', key: '员工构成时间趋势' },
      ],
    },
    {
      title: '支持效能',
      arr: [
        { name: '各行业支持效能', key: '支持效能行业对比' },
        { name: '支持效能时间趋势', key: '支持效能时间趋势' },
      ],
    },
  ];

  const onScroll = () => {
    const topDistance = document.body.scrollTop || document.documentElement.scrollTop;
    // console.log('scroll... ', topDistance);
    if (420 - topDistance > 90) changeTop(420 - topDistance);
    else changeTop(90);
  };

  useEffect(() => {
    onScroll();
    window.addEventListener('scroll', debounce(onScroll, 100));

    return () => {};
  }, []);

  return (
    <section style={{ top: `${siderTop}px` }}
      className={
        // ['sider-20', isExpand ? 'wide-20' : 'narrow-20'].join(' ')
        ['sider-20', 'wide-20'].join(' ')
      }>
      <section className="sider-21"
        onMouseEnter={() => toggleExpand(true)}
        onMouseLeave={() => toggleExpand(false)}>
        {/* {isExpand ? ( */}
        <section className="sider-26">
          {siderList.map((item: any, index: number) => (
            <section key={index} className="head-30">
              {index === 0 ? (
                <HeadButton startIcon={<EffectIcon11 />}>
                  <span className="text-155">{item.title}</span>
                </HeadButton>
              ) : null}
              {index === 1 ? (
                <HeadButton startIcon={<EffectIcon12 />}>
                  <span className="text-155">{item.title}</span>
                </HeadButton>
              ) : null}
              {index === 2 ? (
                <HeadButton startIcon={<EffectIcon13 />}>
                  <span className="text-155">{item.title}</span>
                </HeadButton>
              ) : null}
              {index === 3 ? (
                <HeadButton startIcon={<EffectIcon14 />}>
                  <span className="text-155">{item.title}</span>
                </HeadButton>
              ) : null}
              <section className="title-5055">
                {item.arr.map((child: any, idx: number) => (
                  <TitleButton key={idx}
                    onClick={() => changeModule(child.key)}
                    startIcon={<DownFullIcon color={Color.blackColor(0)} />}
                    className={activeName === child.key ? 'active' : ''}>
                    <span className={[
                      'text-156', activeName === child.key ? 'active' : '',
                    ].join(' ')}>{child.name}
                    </span>
                  </TitleButton>
                ))}
              </section>
            </section>
          ))}
        </section>
        {/* ) : (
          <section className="sider-555">
            <EffectIcon11Gray />
            <b className={activeName === '人效行业对比' ? 'active' : ''} />
            <b className={activeName === '人效时间趋势' ? 'active' : ''} />
            <b className={activeName === '人效变化率分布' ? 'active' : ''} />
            <b className={activeName === '人力资本回报分析' ? 'active' : ''} />
            <b className={activeName === '员工规模与元均效能' ? 'active' : ''} />
            <b className={activeName === 'Top10公司列表' ? 'active' : ''} />
            <b className={activeName === '招聘量与营收' ? 'active' : ''} />
            <EffectIcon12Gray />
            <b className={activeName === '薪酬成本行业对比' ? 'active' : ''} />
            <b className={activeName === '薪酬成本时间趋势' ? 'active' : ''} />
            <b className={activeName === '费用中的薪酬占比' ? 'active' : ''} />
            <EffectIcon13Gray />
            <b className={activeName === '人员配置行业对比' ? 'active' : ''} />
            <b className={activeName === '人员配置时间趋势' ? 'active' : ''} />
            <b className={activeName === '人员配置变化率分布' ? 'active' : ''} />
            <b className={activeName === '员工构成时间趋势' ? 'active' : ''} />
            <EffectIcon14Gray />
            <b className={activeName === '支持效能行业对比' ? 'active' : ''} />
            <b className={activeName === '支持效能时间趋势' ? 'active' : ''} />
          </section>
        )} */}
      </section>
    </section>
  );
};

export default observer(Sider);
